module.exports = __webpack_public_path__ + "img/riccardo-annandale-7e2pe9wjL9M-unsplash.63f8de40.jpg";